import React from 'react';
import useAxios from 'axios-hooks';
import TextField from "../../../../Forms/TextField";
import FluentSelect from '../../../../Forms/FluentSelect';


const schoolTypes = [
  { value: "Two Year Undergraduate", label: "2 Year" },
  { value: "Four Year Undergraduate", label: "4 Year" },
  { value: "Graduate", label: "Graduate" },
];
const studentLevels = [
  { value: "Freshman", label: "Freshman" },
  { value: "Sophomore", label: "Sophomore" },
  { value: "Junior", label: "Junior" },
  { value: "Senior", label: "Senior" },
];
const fullPartTime = [
  { value: "Full-Time", label: "Full-Time" },
  { value: "Part-Time", label: "Part-Time" },
];

const EducationFields = () => {
  const [{ data: fieldsOfStudy, loading }, refetch] = useAxios("scholarships/fields-of-study");

  return (
    <>
      <FluentSelect
          options={schoolTypes}
          isMulti
          name="schoolTypes"
          label={`School Type (Check All That Apply) *`}
          component={FluentSelect}
          required
      />
      <FluentSelect
          options={studentLevels}
          isMulti
          name="studentLevels"
          label={`Year In School (Check All That Apply)`}
          component={FluentSelect}
      />
      <TextField
        label="Institution Details"
        name="institutionDetails"
      />
      <FluentSelect
          options={fullPartTime}
          isMulti
          name="fullPartTime"
          label={`Full or Part Time (Check All That Apply) *`}
          component={FluentSelect}
          required
      />
      <FluentSelect
          options={fieldsOfStudy && [...fieldsOfStudy].sort((a, b) => a.name.localeCompare(b.name)).map(f => ({ value: f.name, label: f.name }))}
          isMulti
          name="fieldsOfStudy"
          label={`Field of Study Category (Optional: Select up to 3)`}
          component={FluentSelect}
      />
     
      <TextField label="Field of Study Details" name="fieldOfStudyDetails" />
      <TextField label="Minimum GPA" name="gpaMin" />
    </>
  );
};

export default EducationFields;
